import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Storage } from '@ionic/storage';

//service
import { ProductService } from '../service/product_service'
import { AppSharedService } from '../service/app_shared';

//types
import { MyCartList } from '../model/types'

//page
import { TabsPage } from '../tabs/tabs';
import { HttpClient, HttpResponse } from '@angular/common/http';


@Component({
  selector: 'page-mycart',
  templateUrl: 'mycart.html',
})

export class MycartPage {

  //class variable
  showEmptyCartMessage: boolean;
  imageUrlResources: string;
  imageUrlSmall: string;
  productUnitMapping: any[] = [];
  unitMasters: any[] = [];
  //constructor
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public prodService: ProductService,
    public appSharedService: AppSharedService,
    private storage: Storage
    , public loadingCtrl: LoadingController
    , private httpc: HttpClient) {
    // initialize variable
    this.showEmptyCartMessage = false;
    this.imageUrlResources = this.appSharedService.configInfo.applicationInfo.fileBasePath + '/Images/AppResources/';
    this.imageUrlSmall = this.appSharedService.configInfo.applicationInfo.fileBasePath + '/' + this.appSharedService.configInfo.applicationInfo.pathThumbnailImageUrl;

    // this.prodService.utility_GetProductListFromCart();
  }

  //initialization
  ngOnInit() {

  }

  GetUnitMaster() {
    //get url
    let url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductUnitForAppv2);
    this.httpc.get(url, { observe: 'response' }).subscribe((res: HttpResponse<any>) => {
      if (res.status == 200) {
        if (res.body != undefined && res.body != null) {
          this.unitMasters = res.body;
        }
      }
    });
  }

  ionViewDidEnter() {
    // debugger;
    this.GetUnitMaster();
    this.prodService.utility_GetProductListFromCart();
  }
  // change product quantity
  changeQty(cartObj: MyCartList, qty: number) {
    this.utility_UpdateQuantityInCart(cartObj, qty);
  }

  //check out button click
  checkout() {
    
    this.navCtrl.setRoot(TabsPage, { tabIndex: 2 });
  }

  getProductUnitMapping(productId: any) {
    let url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductUnitMappingForAppv2 + productId);
    // get product
    this.httpc.get(url, { observe: 'response' }).subscribe((res: HttpResponse<any>) => {
      if (res.status == 200) {
        if (res.body != undefined && res.body != null) {
          this.productUnitMapping = res.body;
        }
      }
    });
  }

  // remove product from cart
  removeFromCart(cartObj: MyCartList) {
    this.storage.get("bz_cart_02").then((data) => {
      if (data != undefined && data.length != null && data.length > 0) {
        let alreadyAdded = false;
        let alreadyAddedIndex = -1;
        for (let i = 0; i < data.length; i++) {
          if (data[i].ProductMappingId == cartObj.ProductMappingId) {
            alreadyAdded = true;
            alreadyAddedIndex = i;
            break;
          }
        }

        if (alreadyAdded) {
          data.splice(alreadyAddedIndex, 1);
        }

        this.storage.set("bz_cart_02", data).then(
          () => {
            this.prodService.utility_GetProductListFromCart();
          }
        );
      }
    });
  }
  // calculate total amount of cart
  utility_calculateCartAmount(data: MyCartList[]): number {
    var Amount = 0;
    if (data != undefined && data != null && data.length > 0) {
      this.showEmptyCartMessage = false;
      for (let i = 0; i < data.length; i++) {
        Amount = Amount + data[i].ProductTotalAmount;
      }
    }
    else {
      this.showEmptyCartMessage = true;
    }
    return Amount;
  }

  //update quantity in cart if click twice
  utility_UpdateQuantityInCart(cartObj: MyCartList, quantity: number) {

    this.storage.get("bz_cart_02").then((data) => {
      if (data != undefined && data.length != null && data.length > 0) {
        let alreadyAdded = false;
        let alreadyAddedIndex = -1;

        for (let i = 0; i < data.length; i++) {
          if (data[i].ProductMappingId == cartObj.ProductMappingId) {
            alreadyAdded = true;
            alreadyAddedIndex = i;
            break;
          }
        }

        //if already added
        if (alreadyAdded == true) {
          data[alreadyAddedIndex].ProductQuantity = data[alreadyAddedIndex].ProductQuantity + quantity;
          if (data[alreadyAddedIndex].ProductQuantity == 0) {
            data[alreadyAddedIndex].ProductQuantity = 1;
          }

          if (data[alreadyAddedIndex].ProductMinQuantity > 0) {
            let itemData = data[alreadyAddedIndex];
            itemData.ProductUnitId = parseInt(itemData.ProductUnitId);
            itemData.ProductQuantity = parseInt(itemData.ProductQuantity);
            let url = (this.appSharedService.configInfo.applicationInfo.apiBasePath + '/' + this.appSharedService.configInfo.urlInfo.urlGetProductUnitAmountForAppv2 + itemData.ProductId + '/unitamount/' + itemData.ProductUnitId + '/' + itemData.ProductQuantity + '/' + itemData.VendorId);
  
            // get product
            this.httpc.get(url, { observe: 'response' }).subscribe((res: HttpResponse<any>) => {
              if (res.status == 200) {
                if (res.body != undefined && res.body != null) {
                  data[alreadyAddedIndex].ProductTotalAmount = res.body;
                }
              }
            });    

          } else {
            data[alreadyAddedIndex].ProductTotalAmount = data[alreadyAddedIndex].ProductQuantity * data[alreadyAddedIndex].ProductPrice;
          }
        }

        this.storage.set("bz_cart_02", data).then(
          () => {
            this.prodService.utility_GetProductListFromCart();
          }
        );
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/mycart/mycart.ts